define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/attributes/attributesConfigLayout.tmpl");
    var Button = require("ui/button/Button");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var AttributesConfigLayout = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        AttributesConfigLayout = Marionette.Layout.extend({
            tagName: 'div',
            className: 'data-sources-edit-container',
            template: template,

            ui: {
                doneButton: ".button-done-edit"
            },
            uiComponents: {
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton"
                    },
                    events: {
                        "click": "_done"
                    }
                }
            },

            regions: {
                mainRegion: '.edit-main-container'
            },


            initialize: function(options){
                LEManager.logger.debug("AttributesConfigLayout:initialize");
                this.savingScraper = false;
                this.vent = LEManager.media.channel("dataSources").vent;
                //this.vent = options.vent;
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.SCRAPER_SAVE,this.onScraperSave, this);
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.SCRAPER_SAVE_DONE,this.onScraperSaveDone, this);
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.AGENT_SAVE,this.onScraperSave, this);
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.AGENT_SAVE_DONE,this.onScraperSaveDone, this);
            },

            onRender: function () {
                LEManager.logger.debug("AttributesConfigLayout:onRender");
                this.listenTo(this, "page:closeButtonClick", this._onCloseButtonClick);
            },

            onScraperSave: function(){
                LEManager.logger.debug("AttributesConfigLayout:onScraperSave");
                this.savingScraper = true;
                this.uiComponents.doneBtn.setState(Button.STATES.DISABLED);
            },

            onScraperSaveDone: function(result){
                LEManager.logger.debug("AttributesConfigLayout:onScraperSaveDone");
                this.savingScraper = false;
                this.uiComponents.doneBtn.setState(Button.STATES.ENABLED);
            },

            _onCloseButtonClick: function (){
                LEManager.logger.debug("AttributesConfigLayout:_onCloseButtonClick - this.savingScraper: " + this.savingScraper);
                if (!this.savingScraper){
                    this.checkBeforeClose();
                }
            },

            checkBeforeClose: function(){
                LEManager.logger.debug("AttributesConfigLayout:checkBeforeClose");
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.ABOUT_TO_CLOSE, this);
            },

            onBeforeClose: function(){
                LEManager.logger.debug("AttributesConfigLayout:onBeforeClose");
                this.uiComponents.doneBtn.close();
            },

            _done: function () {
                LEManager.logger.debug("AttributesConfigLayout:_done");
                if (!this.savingScraper){
                    LEManager.logger.info("User clicked on 'done' button.", "AttributesConfigLayout::_done");
                    this.checkBeforeClose();
                }
            },

            onCancel: function(){
                LEManager.logger.debug("AttributesConfigLayout:onCancel - this.savingScraper: " + this.savingScraper);
                if (!this.savingScraper){
                    LEManager.logger.info("Edit layout cancel is called.", "AttributesConfigLayout::onCancel");
                    this.checkBeforeClose();
                }
            },

            onClose: function(){
                LEManager.logger.debug("AttributesConfigLayout:onClose");
            }
        });

    });
    return AttributesConfigLayout;
});